import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Briefcase, Moon, Zap, User } from 'lucide-react';
const cases = [{
  icon: User,
  text: 'Neck stiffness'
}, {
  icon: Activity,
  text: 'Shoulder tension'
}, {
  icon: Zap,
  text: 'Stress-held tightness'
}, {
  icon: Briefcase,
  text: 'Desk or posture discomfort'
}, {
  icon: Moon,
  text: 'End-of-day stiffness'
}];
export function UseCasesSection() {
  return <section className="py-8 sm:py-12 bg-bone" data-id="element-1446">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-1447">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-6 sm:mb-8" data-id="element-1448">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-light text-charcoal mb-4 tracking-tight" data-id="element-1449">
            Built for Real Necks. Real Routines.
          </h2>
          <p className="text-sm sm:text-base text-charcoal-light font-light" data-id="element-1450">
            GINEXT is used daily by people dealing with:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left" data-id="element-1451">
          {cases.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className={`bg-white p-4 rounded-xl shadow-sm border border-bone-dark flex items-center gap-3 ${index === cases.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-1452">
              <div className="w-8 h-8 bg-ginger/10 rounded-full flex items-center justify-center text-ginger flex-shrink-0" data-id="element-1453">
                <item.icon className="w-4 h-4" data-id="element-1454" />
              </div>
              <span className="text-sm sm:text-base font-light text-charcoal" data-id="element-1455">
                {item.text}
              </span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="mt-6 sm:mt-8 text-sm sm:text-base text-charcoal-light italic font-light" data-id="element-1456">
          This isn't emergency relief. This is daily support that prevents
          buildup.
        </motion.p>
      </div>
    </section>;
}